import { AppState } from '@/vuex/store';
import { resetCustomerFilter } from '@/customer/models/CustomerFilter';
import CustomerGroup from '@/customer/models/CustomerGroup';
import Customer from '@/customer/models/Customer';
import Wxcard from '@/customer/models/Wxcard';

interface Params {
  key: string;
  value: any;
  openid?: string;
  builtIn: boolean;
}

export default {
  UPDATE_CUSTOMER_FILTER: (state: AppState, params: Params) => {
    if (params.key === 'topics') {
      state.customerState.customerFilter = resetCustomerFilter();
    } else {
      state.customerState.customerFilter.topics = [];
    }
    state.customerState.customerFilter[params.key] = params.value;
  },
  RESET_CUSTOMER_QUERY: (state: AppState) => {
    state.customerState.customerFilter = JSON.parse(JSON.stringify(resetCustomerFilter()));
  },
  UPDATE_CUSTOMER_GROUPS: (state: AppState, groups: CustomerGroup[]) => {
    state.customerState.customerGroups = groups;
  },
  SET_MEMBER_CARDS: (state: AppState, cards: Wxcard[]) => {
    state.customerState.memberCards = cards;
  },
  SHOW_TASK_ENTRY: (state: AppState, status: boolean) => {
    state.customerState.showTaskEntry = status;
  },
  SWITCH_FILTER_SCORE_LABEL: (state: AppState, label: string) => {
    const filter = state.customerState.customerFilter;
    if (label === 'scoreSum') {
      if (filter.score) {
        filter.scoreSum = JSON.parse(JSON.stringify(filter.score));
        delete filter.score;
      } 
    } else {
      if (filter.scoreSum) {
        filter.score = JSON.parse(JSON.stringify(filter.scoreSum));
        delete filter.scoreSum;
      }
    }
  },
  UPDATE_CUSTOMER_PROP: (state: AppState, params: Params) => {
    let c = state.customerState.customerList.data.find((c: Customer) => {
      return c.openid === params.openid;
    });
    if (c) {
      setTimeout(() => {
        if (params.builtIn) {
          (c as any)[params.key] = params.value;
          c = JSON.parse(JSON.stringify(c));
        } else {
          (c as any)['privateProps'][params.key] = params.value;
          c = JSON.parse(JSON.stringify(c));
        }
      }, 1000);
    }
    if (state.customerState.currentCustomer &&
        state.customerState.currentCustomer!.openid === params.openid) {
      if (params.builtIn) {
        (state.customerState.currentCustomer as any)[params.key] = params.value;
        state.customerState.currentCustomer = JSON.parse(JSON.stringify(state.customerState.currentCustomer));
      } else {
        (state.customerState.currentCustomer as any)['privateProps'][params.key] = params.value;
        state.customerState.currentCustomer = JSON.parse(JSON.stringify(state.customerState.currentCustomer));
      } 
    }
  },
  UPDATE_CUSTOMER: (state: AppState, customer: Customer) => {
    if (state.customerState.currentCustomer &&
        state.customerState.currentCustomer!.openid === customer.openid) {
      state.customerState.currentCustomer = JSON.parse(JSON.stringify(customer));
    }
    setTimeout(() => {
      state.customerState.customerList.refreshCounter++;
    }, 500);
  },
};
